<template>
  <div>

    <el-dialog :title="Uploadtypestitle"  :visible.sync="dialogShow"  width="70%"  :before-close="handlescreenshotCler">
        <el-upload
          :style="{
            display: Uploadtypes ===  '查看录音' ||  Uploadtypes === '查看截图' ? 'none' : ''
          }"
          class="avatar-uploader"
          ref="upload"
          action="#"
          :on-remove="handleRemove"
          :beforeUpload="beforeUpload"
          :file-list="fileLists"
          :http-request="handleUpload"
          :on-error="handleError"
          :auto-upload="true"
          :show-file-list="false"
          :limit="100"
          drag>
          <i class="el-icon-plus" style="font-size: 50px; line-height: 160px;"></i>

        </el-upload>

        <div v-if="fileListsPush.length > 0" :style="{
              height: Uploadtypes ===  '查看录音' ||  Uploadtypes === '查看截图' ? '50vh' : ''
          }">
          <div v-for="(item,index) in fileListsPush" :key="index" style="margin-top: 10px;margin-left: 10px;">
            <div style="display: flex;">
              <el-input v-model="item.name"></el-input>
              <el-button style="width: 80px; margin-left: 20px;" icon="el-icon-view" type="primary" size="small" @click="handleView('查看',item,index)">查看</el-button>
              <el-button style="width: 80px;" icon="el-icon-download" type="primary" size="small" @click="handleView('下载',item,index)">下载</el-button>
              <el-button style="width: 80px;" icon="el-icon-delete" type="primary" size="small" @click="handleView('删除',item,index)">删除</el-button>
            </div>
          </div>
        </div>

        <div  class="dialog-footer" style=" padding-bottom: 30px; margin-top: 80px;" v-if="Uploadtypes ===  '录音' ||  Uploadtypes === '截图'">
              <el-button @click="handlescreenshotCler" style="margin-right: 50px;">取 消</el-button>
              <el-button type="primary" @click="handlescreenshotSubmit">确 定</el-button>
        </div>

      </el-dialog>


      <el-dialog title="预览MP3" width="50%" style="padding: 0px 50px;height: 50vh;" :visible.sync="showInfosMpsHOW3" :before-close="showshowInfoViewInfoClers3" :close-on-click-modal="false">
          <audio controls>
              <source :src="showInfosMp3" type="audio/ogg">
              <source :src="showInfosMp3" type="audio/mpeg">
              您的浏览器不支持音频。
          </audio>
      </el-dialog>

      <el-dialog title="预览图片" width="80%" style="padding: 0px 50px; height: 80vh;" :visible.sync="showInfoss" :before-close="showshowInfoViewInfoClers5" :close-on-click-modal="false">
          <img :src="urls" :alt="urls" style="width: 80%;">
      </el-dialog>

  </div>
</template>

<script>
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import loadingUtils from "../utils/loading";
import 'animate.css'


export default {
  name: "Elupload",
  props:{
    Uploadtypes: {  type:String,   default:""  },
    fileAllLists:{  type:Array,   default:[]  },
  },
  data() {
    return {

      screenshot:"",
      fileLists:[],


      dialogMessage:false,
      dialogMessageList:[],


      inputValue:"",

      dialogShow:true,

      url:"",
      name:"",

      showUrl:"",
      showUrlDialog:false,

      fileListsPush:[],

      ShowbaseCat:true,
      Uploadtypestitle:'',

      showInfosMpsHOW3:false,
      showInfosMp3:'',
      showInfoss:false,
      urls:'',


    };
  },
  created() {

  },

  mounted(){

    if(this.Uploadtypes === '查看录音'){
        this.Uploadtypestitle = '查看录音'
    }

    if( this.Uploadtypes === '录音'){
        this.Uploadtypestitle = '上传录音'
    }

    if(this.Uploadtypes === '查看截图'){
        this.Uploadtypestitle = '查看截图'
    }

    if(this.Uploadtypes === '截图'){
        this.Uploadtypestitle = '上传证书附件'
    }


    this.fileListsPush = this.fileAllLists

  },

  methods: {

    showshowInfoViewInfoClers3(){
      this.showInfosMp3 = ''
      this.showInfosMpsHOW3 = false
    },

    showshowInfoViewInfoClers5(){
      this.urls = ''
      this.showInfoss = false
    },

    handleView(type, e, index){
      console.log(e)

      if(type === '查看' && (this.Uploadtypes === '截图' || this.Uploadtypes === '查看截图')){
        this.urls = e.url
        this.showInfoss = true
      }

      if(type === '查看' && (this.Uploadtypes === '录音' || this.Uploadtypes === '查看录音')){
        this.showInfosMp3 = e.url
        this.showInfosMpsHOW3 = true
      }

      if(type === '下载'){
        let ele = document.createElement('a')
        ele.setAttribute('href', e.url)
        document.body.appendChild(ele)
        ele.click()
      }

      if(type === '删除'){
        this.fileListsPush.splice(index, 1)
      }

    },

    handlescreenshotCler(flieList){
      this.$emit('handleEventElUpload',flieList)
    },


    handlescreenshotSubmit(){

      if(this.fileListsPush.length > 0){
        this.$emit('handleEventElUploadSubt',this.fileListsPush)
      }else{
        this.$message({ showClose: true,  message: '请选择文件',  type: 'warning' });
      }
    },

    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },

    beforeUpload(file) {
      loadingUtils.startLoading()
      const fileExtensions =
        this.getFileName(file.name) === ".bmp" ||
        this.getFileName(file.name) === ".tif" ||
        this.getFileName(file.name) === ".gif" ||
        this.getFileName(file.name) === ".pcx" ||
        this.getFileName(file.name) === ".svg" ||
        this.getFileName(file.name) === ".psd" ||
        this.getFileName(file.name) === ".webp" ||
        this.getFileName(file.name) === ".apng" ||
        this.getFileName(file.name) === ".ai" ||
        this.getFileName(file.name) === ".avif" ||
        this.getFileName(file.name) === ".png" ||
        this.getFileName(file.name) === ".pdf"||
        this.getFileName(file.name) === ".mp4"||
        this.getFileName(file.name) === ".excel"||
        this.getFileName(file.name) === ".doc"||
        this.getFileName(file.name) === ".ppt"||
        this.getFileName(file.name) === ".mp3"||
        this.getFileName(file.name) === ".xls"||
        this.getFileName(file.name) === ".xlsx"||
        this.getFileName(file.name) === ".pptx"||
        this.getFileName(file.name) === ".docx"||
        this.getFileName(file.name) === ".txt"||
        this.getFileName(file.name) === ".jpg";
      const max20M = file.size / 1024 / 1024 < 1000;
      if (!fileExtensions) {
        this.$message.error("上传文件类不合格式!");
        loadingUtils.endLoading();
      }
      if (!max20M) {
        this.$message.error("上传文件大小不能超过 1000MB!");
        loadingUtils.endLoading();
      }
      this.fileLists.push(file);
      return fileExtensions && max20M;
    },
    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      put(`mz_pc/${objName}`, option.file).then((res) => {

        let indexs = option.file.name.lastIndexOf(".")
        let file = { url: res.url, name: option.file.name.substring(0, indexs) }

        this.fileListsPush.push(file)

        loadingUtils.endLoading();
        this.screenshot = res.url
        signatureUrl(`mz_pc/${objName}`).then((res) => {

        });
      });
    },
    handleRemove(file, fileList) {
      this.fileLists = fileList;


      this.fileListsPush = this.fileListsPush.filter((itme)=>{
        return itme.name !== fileList[0].name
      })

      this.screenshot = ""
    },

    handleError(){
      loadingUtils.endLoading();
    },


  },

  beforeDestroy(){

  }

};
</script>


<style scoped>


.btns{
  background-color: rgb(78, 140, 255);
  border-color: rgb(78, 140, 255);
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/teamOrganization/Elupload.vue